import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

interface PasswordInputProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  name?: string;
  required?: boolean;
}

export default function PasswordInput({
  label,
  value,
  onChange,
  placeholder = 'Enter password',
  error,
  name,
  required,
}: PasswordInputProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="flex flex-col gap-1 w-full">
      {label && (
        <label className="text-sm text-white">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        <input
          type={show ? 'text' : 'password'}
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full px-3 py-2 rounded-md bg-transparent border border-white/20 text-white pr-10 focus:border-blue-500 outline-none"
        />

        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"
        >
          {show ? <Eye size={18} /> : <EyeOff size={18} />}
        </button>
      </div>

      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
}
